// TEST öğrencisi - Şadiye PATCI velisi
const testStudent = {
  id: 999,
  schoolNumber: "TEST",
  name: "TEST ÖĞRENCİSİ",
  parentName: "Şadiye PATCI",
  parentPhone: "+90 543 584 38 33",
  parentTelegram: "1318339399", // Şadiye Hanım'ın chat ID'si
  birthDate: "1983-03-23",
  avatar: "/images/avatars/test.png"
};

// Şadiye Hanım'ın 4/P sınıfı öğrencileri
const baseStudents = [
  { id: 1, schoolNumber: "1216", name: "ADEM BERK KEÇELİOĞLU", parentName: "FİLİZ", parentPhone: "+905075712131", parentTelegram: "8570336304", birthDate: "2016-01-11", avatar: "/images/avatars/adem.jpg" },
  { id: 2, schoolNumber: "1230", name: "AHMET YELER", parentName: "CENNET", parentPhone: "+905547429721", parentTelegram: "8481137165", birthDate: "2016-01-04", avatar: "/images/avatars/ahmet.jpg" },
  { id: 3, schoolNumber: "1233", name: "ALİ GÖÇTÜ", parentName: "PEMBE", parentPhone: "+905438178137", parentTelegram: "8483363079", birthDate: "2016-05-04", avatar: "/images/avatars/ali.jpg" },
  { id: 4, schoolNumber: "1081", name: "ARAS ALP COŞKUNLAR", parentName: "PERİHAN", parentPhone: "+905078296449", parentTelegram: "6049601464", birthDate: "2015-12-03", avatar: "/images/avatars/aras.jpg" },
  { id: 5, schoolNumber: "1246", name: "AYŞENUR ARGIN", parentName: "LEYLA", parentPhone: "+905443423801", parentTelegram: "8567381679", birthDate: "2015-11-17", avatar: "/images/avatars/aysenur.jpg" },
  { id: 6, schoolNumber: "865", name: "BEDİA SENA TUTUMLU", parentName: "ZENNUR", parentPhone: "+905366621620", parentTelegram: "8544514933", birthDate: "2016-01-06", avatar: "/images/avatars/bedia.jpg" },
  { id: 7, schoolNumber: "685", name: "BİLGE İNCİHACILAR", parentName: "BEDRİYE TUBA", parentPhone: "+905526314189", parentTelegram: "5624091399", birthDate: "2016-12-06", avatar: "/images/avatars/bilge.jpg" },
  { id: 8, schoolNumber: "355", name: "CEYDA İLHAN", parentName: "YASEMİN", parentPhone: "+905077234724", parentTelegram: "7987277294", birthDate: "2016-12-13", avatar: "/images/avatars/ceyda.jpg" },
  { id: 9, schoolNumber: "1268", name: "CENNET SU ERDAL", parentName: "İPEK", parentPhone: "+905469221577", parentTelegram: "8245383312", birthDate: "2016-05-10", avatar: "/images/avatars/cennet.jpg" },
  { id: 10, schoolNumber: "1367", name: "EDİZ EGE AKIN", parentName: "GÜLLÜ", parentPhone: "+905541372862", parentTelegram: "1491381786", birthDate: "2015-12-24", avatar: "/images/avatars/ediz.jpg" },
  { id: 11, schoolNumber: "1273", name: "EGE ÇIRPAN", parentName: "FUNDA", parentPhone: "+905336776696", parentTelegram: "7345840306", birthDate: "2015-12-18", avatar: "/images/avatars/ege.jpg" },
  { id: 12, schoolNumber: "629", name: "ELİF KARAGÖNLÜ", parentName: "ÖZGE", parentPhone: "+905466924689", parentTelegram: "8579122685", birthDate: "2016-09-26", avatar: "/images/avatars/elif_k.jpg" },
  { id: 13, schoolNumber: "310", name: "ELİF SU ALDIRMAZ", parentName: "MAKBULE", parentPhone: "+905455649517", parentTelegram: "1510580892", birthDate: "2016-02-16", avatar: "/images/avatars/elif_s.jpg" },
  { id: 14, schoolNumber: "1277", name: "EMRE ÇAKAL", parentName: "ŞENGÜL", parentPhone: "+905375903560", parentTelegram: "8468709823", birthDate: "2016-08-25", avatar: "/images/avatars/emre.jpg" },
  { id: 15, schoolNumber: "464", name: "ENES KUTAY PİYAN", parentName: "CEMİLE", parentPhone: "+905519802342", parentTelegram: "8561234929", birthDate: "2015-08-06", avatar: "/images/avatars/enes.jpg" },
  { id: 16, schoolNumber: "1280", name: "ERCAN TOKDİL", parentName: "KÜBRA", parentPhone: "+905343543025", parentTelegram: "8511035714", birthDate: "2016-04-06", avatar: "/images/avatars/ercan.jpg" },
  { id: 17, schoolNumber: "542", name: "GÜLSÜM AZRA MANCAR", parentName: "HAVVA", parentPhone: "+905317417303", parentTelegram: "8033323221", birthDate: "2016-04-13", avatar: "/images/avatars/gulsum.jpg" },
  { id: 18, schoolNumber: "1619", name: "HATİCE CEYLİN AYDIN", parentName: "RAZİYE", parentPhone: "+905301428598", parentTelegram: "8248262251", birthDate: "2016-05-10", avatar: "/images/avatars/hatice.jpg" },
  { id: 19, schoolNumber: "1300", name: "MEDİNE HANIM YELER", parentName: "CENNET", parentPhone: "+905547429721", parentTelegram: "8481137165", birthDate: "2016-01-04", avatar: "/images/avatars/medine.jpg" },
  { id: 20, schoolNumber: "1361", name: "OĞUZHAN ÖZKAN", parentName: "GÜLÇİN", parentPhone: "+905548745217", parentTelegram: "5567422080", birthDate: "2016-03-30", avatar: "/images/avatars/oguzhan.jpg" },
  { id: 21, schoolNumber: "303", name: "ÖMER ASAF KILINÇ", parentName: "SULTAN", parentPhone: "+905469564319", parentTelegram: "8277560892", birthDate: "2016-06-27", avatar: "/images/avatars/omer.jpg" },
  { id: 22, schoolNumber: "1365", name: "RABİA RENÇBER", parentName: "FATMA", parentPhone: "+905425488582", parentTelegram: "8594862197", birthDate: "2016-05-08", avatar: "/images/avatars/rabia.jpg" },
  { id: 23, schoolNumber: "717", name: "RANA TARCAN", parentName: "NURAY", parentPhone: "+905449058038", parentTelegram: "8269149248", birthDate: "2016-06-15", avatar: "/images/avatars/rana.jpg" },
  { id: 25, schoolNumber: "143", name: "SELAHATTİN AHLAS SU", parentName: "KADRİYE", parentPhone: "+905550406636", parentTelegram: "1530588619", birthDate: "2016-03-10", avatar: "/images/avatars/selahattin.jpg" },
  { id: 26, schoolNumber: "546", name: "SELİME HÜMDA ABACI", parentName: "FATMA", parentPhone: "+905418579381", parentTelegram: "6856005363", birthDate: "2017-02-06", avatar: "/images/avatars/selime.jpg" },
  { id: 27, schoolNumber: "1395", name: "SELİM KARAKUŞ", parentName: "HALİME", parentPhone: "+905465693751", parentTelegram: "8455897740", birthDate: "2015-12-22", avatar: "/images/avatars/selim.jpg" },
  { id: 28, schoolNumber: "1431", name: "SERRA BAŞ", parentName: "CENNET", parentPhone: "+905356335980", parentTelegram: "8574434410", birthDate: "2016-07-25", avatar: "/images/avatars/serra.jpg" },
  { id: 29, schoolNumber: "1100", name: "SUAT ARAS ÖCAL", parentName: "SERGÜL", parentPhone: "+905458958835", parentTelegram: "1503565645", birthDate: "2016-01-04", avatar: "/images/avatars/suat.jpg" },
  { id: 30, schoolNumber: "158", name: "YİĞİT EFE ÇAKIR", parentName: "ŞULE", parentPhone: "+905335479292", parentTelegram: "8313853527", birthDate: "2016-04-30", avatar: "/images/avatars/yigit.jpg" },
  { id: 31, schoolNumber: "245", name: "ZEYNEP DEMİRKAN", parentName: "FATİME", parentPhone: "+905075104032", parentTelegram: "8540366522", birthDate: "2016-03-01", avatar: "/images/avatars/zeynep_d.jpg" },
  { id: 32, schoolNumber: "1505", name: "ZEYNEP KARAKAYA", parentName: "HİLAL", parentPhone: "+905528282330", parentTelegram: "8594297956", birthDate: "2016-08-25", avatar: "/images/avatars/zeynep_k.jpg" }
];

// Öğrencilere ekonomi sistemi için başlangıç bakiyesi ekle
const studentsWithEconomy = [testStudent, ...baseStudents].map(student => ({
  ...student,
  economy: {
    balance: 0,
    totalEarned: 0,
    totalSpent: 0,
    badges: [],
    privileges: [],
    transactions: []
  }
}));

export const students = studentsWithEconomy;

// Doğum günü tebrik mesajı şablonu
export const birthdayMessageTemplate = `🎂 Doğum Günü Tebrik Mesajı 🎂

Sayın [Veli Adı],

Bugün [Öğrenci Adı]'nın doğum günü vesilesiyle, kendisine sınıfım adına en içten tebriklerimi iletiyorum.
Yeni yaşının; sağlık, huzur, mutluluk ve akademik başarılarla dolu geçmesini dilerim.

Şadiye PATCI
4/P Sınıf Öğretmeni`;

export const evaluationTypes = [
  { value: 1, label: "Geliştirilmeli", color: "#f44336" },
  { value: 2, label: "Yeterli", color: "#ff9800" },
  { value: 3, label: "İyi", color: "#4caf50" },
  { value: 4, label: "Çok İyi", color: "#2196f3" }
];

export const classInfo = {
  school: "VALİ RECEP YAZICIOĞLU İLKOKULU",
  className: "4/P Sınıfı",
  teacher: "Şadiye PATCI",
  teacherPhone: "+90 543 584 38 33",
  teacherTelegram: "@SadiyePatci",
  counselor: {
    name: "Cafer Tayyar Karatay",
    title: "Rehber Öğretmen",
    phone: "+90 536 824 24 22",
    telegram: "@cafer_karatay"
  }
};

export const subjects = {
  sosyalBilgiler: {
    name: "Sosyal Bilgiler",
    color: "#4CAF50",
    weeklyTests: true
  },
  turkce: {
    name: "Türkçe",
    color: "#FF5722",
    weeklyTests: true
  },
  matematik: {
    name: "Matematik",
    color: "#2196F3",
    weeklyTests: true
  },
  fenBilimleri: {
    name: "Fen Bilimleri",
    color: "#9C27B0",
    weeklyTests: true
  }
};

// Telegram'dan gelen chat ID'leri buraya kaydedilecek
export const telegramChatIds = [
  // Örnek: { parentName: "FİLİZ KEÇELİOĞLU", chatId: "123456789", registeredAt: "2024-01-15 10:30" }
];

export const behaviorIssues = [
  { code: "D01", description: "Akranına karşı şiddet kullanmak", type: "serious_incident" },
  { code: "D02", description: "Akranına kötü sözler kullanmak", type: "serious_incident" },
  { code: "D03", description: "Ders anında gürültüye neden olma nedeniyle uyarılma sayısı", type: "daily_count" },
  { code: "D04", description: "Ders anında yemek yeme ve içecek içmek", type: "daily_count" },
  { code: "D05", description: "Derse geç kalmak", type: "daily_count" },
  { code: "D06", description: "Derste başkalarıyla konuşma nedeniyle uyarılma sayısı", type: "daily_count" },
  { code: "D07", description: "Okul içinde yüksek sesle ve koşarak hareket etmek", type: "daily_count" },
  { code: "D08", description: "Sırasını ve sınıfını kirletmek", type: "daily_count" },
  { code: "D09", description: "Ödevini zamanında teslim etmedi", type: "daily_count" },
  { code: "D10", description: "Yazı görevini eksik yapmak", type: "daily_count" }
];

export const messagingConfig = {
  daily: {
    sendTime: "17:15",
    autoSend: true
  },
  weekly: {
    sendTime: "19:30",
    sendDay: 5,
    autoSend: true
  }
};

export const smartMessageTemplates = {
  weekly_academic: "Sayın {parentName}, {studentName} bu hafta {subjects} derslerinde genel olarak {overallPerformance} performans gösterdi.",
  daily_behavior: "Sayın {parentName}, {studentName} bugün {behaviorSummary} davranış sergiledi."
};

// Sınıf Ekonomisi Sistemi
// Özel Günler ve Temalar
export const specialDays = {
  // EYLÜL
  '09-07': { 
    title: 'TEMİZ HAVA GÜNÜ',
    message: 'Temiz hava solumak için doğayı koruyalım!',
    icon: '🌬️',
    colors: { primary: '#48C9B0', secondary: '#1ABC9C' }
  },
  
  '09-19': { 
    title: 'GAZİLER GÜNÜ',
    message: 'Gazilerimize minnettarız, teşekkür ederiz!',
    icon: '🎖️',
    colors: { primary: '#e74c3c', secondary: '#c0392b' }
  },
  
  '09-28': { 
    title: 'OKUL SÜTÜ GÜNÜ',
    message: 'Süt içerek güçlü ve sağlıklı büyüyoruz!',
    icon: '🥛',
    colors: { primary: '#3498db', secondary: '#ecf0f1' }
  },
  
  // EKİM
  '10-04': { 
    title: 'HAYVANLARI KORUMA GÜNÜ',
    message: 'Tüm canlılar dostumuz, onları koruyalım!',
    icon: '🐾',
    colors: { primary: '#27ae60', secondary: '#2ecc71' }
  },
  
  '10-13': { 
    title: 'DÜNYA AFET AZALTMA GÜNÜ',
    message: 'Afetlere karşı hazırlıklı olalım, güvende kalalım!',
    icon: '🌍',
    colors: { primary: '#e67e22', secondary: '#d35400' }
  },
  
  '10-24': { 
    title: 'BİRLEŞMİŞ MİLLETLER GÜNÜ',
    message: 'Tüm dünya çocukları kardeştir!',
    icon: '🌐',
    colors: { primary: '#3498db', secondary: '#2980b9' }
  },
  
  '10-29': { 
    title: 'CUMHURİYET BAYRAMI',
    message: 'Cumhuriyetimizin 102. yılını kutluyoruz!',
    icon: '❤️',
    colors: { primary: '#e30a17', secondary: '#ffffff' }
  },
  
  // KASIM
  '11-07': { 
    title: 'ARA TATİL BAŞLIYOR',
    message: 'Tatilin tadını çıkar, dinlen ve eğlen!',
    icon: '🏖️',
    colors: { primary: '#f39c12', secondary: '#e67e22' }
  },
  
  '11-10': { 
    title: 'ATATÜRK ANMA GÜNÜ',
    message: 'Atatürk saygı ve sevgiyle anıyoruz',
    icon: '❤️',
    colors: { primary: '#2c3e50', secondary: '#34495e' }
  },
  
  '11-12': { 
    title: 'AFET EĞİTİMİ GÜNÜ',
    message: 'Depremde ne yapmalıyız? Birlikte öğrenelim!',
    icon: '🚨',
    colors: { primary: '#e74c3c', secondary: '#c0392b' }
  },
  
  '11-14': { 
    title: 'DÜNYA DİYABET GÜNÜ',
    message: 'Sağlıklı beslenip bol bol hareket edelim!',
    icon: '💙',
    colors: { primary: '#3498db', secondary: '#2980b9' }
  },
  
  '11-20': { 
    title: 'ÇOCUK HAKLARI GÜNÜ',
    message: 'Her çocuğun oyun oynama ve öğrenme hakkı var!',
    icon: '🎈',
    colors: { primary: '#e74c3c', secondary: '#f39c12' }
  },
  
  '11-24': { 
    title: 'ÖĞRETMENLER GÜNÜ KUTLU OLSUN',
    message: 'Yüreğimin sessiz sızılarını, gecenin koynunda dinlendiririm; çünkü sabah olduğunda yüzünüzde umut olsun isterim. Öğretmenin bedeli ağırdır, ama o ağırlığın altında en büyük güç, sizde gördüğüm ışıktır.\nŞadiye PATCI',
    icon: '📚',
    colors: { primary: '#3498db', secondary: '#2ecc71' }
  },
  
  // ARALIK
  '12-03': { 
    title: 'ENGELLİLER GÜNÜ',
    message: 'Farklılıklarımız bizi özel yapar!',
    icon: '🦽',
    colors: { primary: '#9b59b6', secondary: '#8e44ad' }
  },
  
  '12-04': { 
    title: 'MADENCİLER GÜNÜ',
    message: 'Madencilerimize teşekkür ederiz!',
    icon: '⛏️',
    colors: { primary: '#95a5a6', secondary: '#7f8c8d' }
  },
  
  '12-05': { 
    title: 'KADIN SEÇME VE SEÇİLME HAKKI',
    message: 'Kadınlarımız her alanda başarılı!',
    icon: '🗳️',
    colors: { primary: '#e91e63', secondary: '#9c27b0' }
  },
  
  '12-10': { 
    title: 'İNSAN HAKLARI GÜNÜ',
    message: 'Herkes eşit haklara sahiptir!',
    icon: '✊',
    colors: { primary: '#e67e22', secondary: '#d35400' }
  },
  
  '12-12': { 
    title: 'YERLİ MALI HAFTASI BAŞLIYOR',
    message: 'Türk mallarını tercih edelim, ülkemizi destekleyelim!',
    icon: '🇹🇷',
    colors: { primary: '#e30a17', secondary: '#ffffff' }
  },
  
  '12-13': { 
    title: 'YERLİ MALI HAFTASI',
    message: 'Yerli üretimi destekleyerek ekonomimize katkı sağlayalım!',
    icon: '🏭',
    colors: { primary: '#e30a17', secondary: '#ffffff' }
  },
  
  '12-14': { 
    title: 'YERLİ MALI HAFTASI',
    message: 'Türk çiftçisinin emeğini, Türk işçisinin alın terini destekleyelim!',
    icon: '🌾',
    colors: { primary: '#e30a17', secondary: '#ffffff' }
  },
  
  '12-15': { 
    title: 'YERLİ MALI HAFTASI',
    message: 'Made in Turkey etiketli ürünleri gururla kullanalım!',
    icon: '🏷️',
    colors: { primary: '#e30a17', secondary: '#ffffff' }
  },
  
  '12-16': { 
    title: 'YERLİ MALI HAFTASI',
    message: 'Yerli malı kullanmak vatanseverlik, milli görevdir!',
    icon: '❤️',
    colors: { primary: '#e30a17', secondary: '#ffffff' }
  },
  
  '12-17': { 
    title: 'YERLİ MALI HAFTASI',
    message: 'Türk sanayisini destekleyerek geleceğimizi inşa ediyoruz!',
    icon: '🏗️',
    colors: { primary: '#e30a17', secondary: '#ffffff' }
  },
  
  '12-18': { 
    title: 'YERLİ MALI HAFTASI SON GÜN',
    message: 'Yerli malı kullanma bilincini her gün yaşayalım!',
    icon: '🇹🇷',
    colors: { primary: '#e30a17', secondary: '#ffffff' }
  },
  
  '12-29': { 
    title: 'YENİ YIL HEYECANI',
    message: 'Yeni yıl yaklaşıyor, yeni umutlar getiriyor!',
    icon: '🎊',
    colors: { primary: '#f39c12', secondary: '#e74c3c' }
  },
  
  '12-30': { 
    title: 'YENİ YIL GELİYOR',
    message: 'Yarın yeni bir yıla merhaba diyeceğiz!',
    icon: '🎆',
    colors: { primary: '#9b59b6', secondary: '#3498db' }
  },
  
  '12-31': { 
    title: 'YILBAŞI',
    message: 'Mutlu yıllar! Hep birlikte güzel bir yıl geçirelim!',
    icon: '🎉',
    colors: { primary: '#e74c3c', secondary: '#f1c40f' }
  },
  
  // MART
  '03-08': { 
    title: 'KADINLAR GÜNÜ',
    message: 'Annelerimiz, öğretmenlerimiz çok değerli!',
    icon: '🌸',
    colors: { primary: '#e91e63', secondary: '#f8bbd0' }
  },
  
  '03-12': { 
    title: 'İSTİKLAL MARŞI GÜNÜ',
    message: 'İstiklal Marşımızı gururla söylüyoruz!',
    icon: '❤️',
    colors: { primary: '#e30a17', secondary: '#c0392b' }
  },
  
  '03-18': { 
    title: 'ÇANAKKALE ZAFERİ',
    message: 'Şehitlerimizi minnetle anıyoruz!',
    icon: '❤️',
    colors: { primary: '#e30a17', secondary: '#c0392b' }
  },
  
  '03-22': { 
    title: 'DÜNYA SU GÜNÜ',
    message: 'Su çok değerli, israf etmeyelim!',
    icon: '💧',
    colors: { primary: '#3498db', secondary: '#5dade2' }
  },
  
  '03-27': { 
    title: 'DÜNYA TİYATRO GÜNÜ',
    message: 'Tiyatro oynamak çok eğlenceli!',
    icon: '🎭',
    colors: { primary: '#9b59b6', secondary: '#8e44ad' }
  },
  
  // NİSAN
  '04-02': { 
    title: 'OTİZM FARKINDALIĞI GÜNÜ',
    message: 'Herkes özeldir, herkese saygı gösterelim!',
    icon: '🧩',
    colors: { primary: '#3498db', secondary: '#5dade2' }
  },
  
  '04-07': { 
    title: 'DÜNYA SAĞLIK GÜNÜ',
    message: 'Sağlıklı olmak için bol bol hareket!',
    icon: '🏥',
    colors: { primary: '#e74c3c', secondary: '#ecf0f1' }
  },
  
  '04-23': { 
    title: 'ÇOCUK BAYRAMI',
    message: '23 Nisan coşkuyla kutlu olsun!',
    icon: '❤️',
    colors: { primary: '#e74c3c', secondary: '#f39c12' }
  },
  
  '04-26': { 
    title: 'FİKRİ MÜLKİYET GÜNÜ',
    message: 'Fikirlerimiz değerli, koruyalım!',
    icon: '💡',
    colors: { primary: '#f39c12', secondary: '#f1c40f' }
  },
  
  '04-29': { 
    title: 'KUT\'ÜL AMARE ZAFERİ',
    message: 'Zaferlerimizi gururla anıyoruz!',
    icon: '❤️',
    colors: { primary: '#e30a17', secondary: '#c0392b' }
  },
  
  // MAYIS
  '05-19': { 
    title: 'GENÇLİK VE SPOR BAYRAMI',
    message: 'Spor yaparak güçlü ve sağlıklı oluyoruz!',
    icon: '❤️',
    colors: { primary: '#e74c3c', secondary: '#2ecc71' }
  },
  
  '05-25': { 
    title: 'ETİK GÜNÜ',
    message: 'Dürüst ve iyi insanlar olmaya çalışalım!',
    icon: '⚖️',
    colors: { primary: '#34495e', secondary: '#95a5a6' }
  },
  
  '05-29': { 
    title: 'İSTANBUL\'UN FETHİ',
    message: 'İstanbulumuz çok güzel!',
    icon: '❤️',
    colors: { primary: '#e30a17', secondary: '#c0392b' }
  }
};

// Bugünün temasını getiren fonksiyon
export function getTodayTheme() {
  const today = new Date();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  const key = `${month}-${day}`;
  
  const specialDay = specialDays[key];
  
  if (specialDay) {
    return {
      type: 'special',
      title: specialDay.title,
      message: specialDay.message,
      icon: specialDay.icon,
      colors: specialDay.colors
    };
  }
  
  return {
    type: 'normal',
    title: 'Sevgili Öğrencilerim',
    message: NORMAL_DAY_QUOTE_TEXT,
    icon: '🌸',
    colors: {
      primary: '#e91e63',
      secondary: '#f8bbd0'
    }
  };
}

export const NORMAL_DAY_QUOTE_TEXT = "Sevgili yıldızlarım, bugün davranışlarımızla da parlayalım. Her güzel davranış bir ışık yakar.";
export const NORMAL_DAY_QUOTE_AUTHOR = "Şadiye PATCI";

// Test fonksiyonu - console'da kullan
if (typeof window !== 'undefined') {
  window.testTheme = () => {
    const theme = getTodayTheme();
    console.log('🎨 Bugünkü tema:', theme);
    console.log('📅 Tarih:', new Date().toLocaleDateString('tr-TR'));
    return theme;
  };
}

export const classEconomy = {
  currency: {
    name: "Yıldız Puanı",
    symbol: "⭐",
    emoji: "🌟"
  },
  rewards: {
    academic: {
      4: 10, // Çok İyi = 10 Yıldız Puanı
      3: 7,  // İyi = 7 Yıldız Puanı
      2: 3,  // Yeterli = 3 Yıldız Puanı
      1: 0   // Geliştirilmeli = 0 Yıldız Puanı
    },
    behavior: {
      // 3. sınıf seviyesi davranış ödülleri
      academic_organization: 8,    // Temiz çalışma alanı, malzeme düzeni
      academic_focus: 10,          // Dikkatli dinleme
      academic_participation: 12,   // Ders etkinliklerine katılım
      academic_readiness: 6,       // Zil çaldığında hazır olma
      school_citizenship: 15,      // Törende uygun davranış
      physical_participation: 10,   // Beden eğitimi katılımı
      health_habits: 8,            // Beslenme kuralları
      classroom_citizenship: 12,    // Sınıf kurallarını takip etme
      creativity: 12,              // Yaratıcılık ödülü
      leadership: 15,              // Liderlik ödülü
      courage: 10,                 // Cesaret ödülü
      weekly_achievement: 25,      // Haftalık MVP
      monthly_achievement: 50,     // Aylık şampiyon
      term_achievement: 100,       // Dönem yıldızı
      special_recognition: 30,     // Misafir övgüsü
      teacher_appreciation: 15,    // Öğretmen teşekkürü
      improvement: 18,             // Gelişim ödülü
      effort: 12                   // Çaba ödülü
    },
    bonus: {
      weeklyLeader: 20,   // Haftalık lider = 20 Yıldız Puanı
      monthlyLeader: 50,  // Aylık lider = 50 Yıldız Puanı
      perfectWeek: 15     // Mükemmel hafta = 15 Yıldız Puanı
    }
  },
  store: [
    {
      id: 1,
      name: "Öğretmenim ve Annemle Hafta Sonu Gezisi",
      description: "Öğretmen ve veli ile özel gezi",
      price: 1250,
      emoji: "🚌",
      category: "vip",
      available: true
    },
    {
      id: 2,
      name: "Öğretmen Asistanı",
      description: "Bir hafta öğretmen yardımcısı",
      price: 1000,
      emoji: "📚",
      category: "privilege",
      available: true
    },
    {
      id: 3,
      name: "Sıra Lideri",
      description: "Bir hafta sıra lideri unvanı",
      price: 950,
      emoji: "⭐",
      category: "leadership",
      available: true
    },
    {
      id: 4,
      name: "Teneffüs Lideri",
      description: "Teneffüs aktivitelerini yönetme",
      price: 900,
      emoji: "🏃",
      category: "leadership",
      available: true
    },
    {
      id: 5,
      name: "Serbest Kıyafet",
      description: "Bir hafta serbest kıyafet hakkı",
      price: 800,
      emoji: "👕",
      category: "privilege",
      available: true
    },
    {
      id: 6,
      name: "Akıllı Tahtadan İçerik Seçme",
      description: "Ders aralarında içerik seçme hakkı",
      price: 800,
      emoji: "📺",
      category: "privilege",
      available: true
    },
    {
      id: 7,
      name: "VIP Fotoğraf + Panoya Asılma",
      description: "Özel fotoğraf çekimi ve panoya asılma",
      price: 750,
      emoji: "📸",
      category: "vip",
      available: true
    },
    {
      id: 8,
      name: "Oyun Seçme Hakkı",
      description: "Teneffüste oyun belirleme hakkı",
      price: 750,
      emoji: "🎲",
      category: "privilege",
      available: true
    },
    {
      id: 9,
      name: "Kantin Alışveriş Kuponu",
      description: "Kantinden alışveriş kuponu",
      price: 750,
      emoji: "🛒",
      category: "reward",
      available: true
    },
    {
      id: 10,
      name: "Veliye Özel Teşekkür",
      description: "Velilere özel teşekkür mesajı",
      price: 500,
      emoji: "📜",
      category: "special",
      available: true
    }
  ]
};